var Base = require('_js/base');

function UserProfileBlock() {
  this.init();
}

UserProfileBlock.prototype = new Base();

UserProfileBlock.prototype.init = function() {
  //Accordion on mobile
  var $accordion = $('.user-profile-block-conatiner.accordion-single');
  $accordion.on('click', function() {
    $(this).toggleClass('is-active');
  });
};

module.exports = UserProfileBlock;
